import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation, useHistory } from 'react-router-dom';
import { api_crud_base, api_crud_route, api_list_route, endpoints } from './Config';
import { reqGET, reqDELETE, translate } from '../../../../Utils';
import { getTokenInfo } from '../../../../UseToken';
import UseSidebar from '../../../../UseSidebar';
import Loader from '../../../Loader/Loader';
import Swal from 'sweetalert2'
import { language } from './Language';
import { color } from "../../../WEBContent/Color";
import { icon } from "../../../WEBContent/Icon"

const tipo_jogo_lista = [
    { value: 'conference', label: 'Conference' },
    { value: 'non_conference', label: 'Non-Conference' },
    { value: 'playoff', label: 'Playoff Game' },
];

const modalidades_lista = [
    { value: 'curling', label: 'Curling' },
    { value: 'hoquei_no_gelo', label: 'Hóquei no gelo' },
];

const get_label = (lista, value) => lista.find(o => o.value === value)?.label ?? value ?? '';

const get_jogo_label = (info) => {
    const casa = info?.equipa_casa?.label ?? '-'
    const visitante = info?.equipa_visitante?.label ?? '-'
    return `${casa} vs ${visitante}`
}

const normalizar_epoca = (valor) => {
    if (!valor) return ''
    const partes = String(valor).split('/').map(p => p.trim())
    if (partes.length !== 2) return String(valor).trim()
    const [inicio, fim] = partes
    if (fim.length === 4) return `${inicio}/${fim}`
    if (fim.length === 2 && inicio.length === 4) return `${inicio}/${inicio.slice(0, 2)}${fim}`
    return `${inicio}/${fim}`
}

const get_epoca_atual = () => {
    const hoje = new Date()
    const ano = hoje.getFullYear()
    const mes = hoje.getMonth()
    return (mes >= 7) ? `${ano}/${ano + 1}` : `${ano - 1}/${ano}`
}

const estilo_pill = (ativo) => ({
    display: 'inline-block',
    padding: '3px 10px',
    fontSize: '11px',
    lineHeight: 1.4,
    borderRadius: '12px',
    border: `1px solid ${color.corPrimaria.rgb}`,
    background: ativo ? color.corPrimaria.rgb : '#fff',
    color: ativo ? '#fff' : color.corPrimaria.rgb,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
})

export default function List() {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);
    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);
    const [lang, set_lang] = useState('pt');
    const { pathname } = useLocation();
    const history = useHistory();
    const [, set_sidebar] = useState([])
    const [, setRefresh] = useState(0)
    const [pesquisa, set_pesquisa] = useState('');
    const [modalidade_filtro, set_modalidade_filtro] = useState('');
    const [temporada_filtro, set_temporada_filtro] = useState('');
    const [temporadas_lista, set_temporadas_lista] = useState([]);
    const temporada_auto_definida = useRef(false);

    const [competicoes, set_competicoes] = useState([]);

    const handleRowClick = (row) => {
        // history.push({ pathname: endpoints.view, state: { item: row, operation: 'view' } })
    };

    const fetch_id_info = async () => {
        reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                setData(res.data)
            })
            .catch(() => 404
            )
    }

    const fetch_temporadas = async (type) => {
        let res = await reqGET(`${api_crud_base}/intranet/components/type/${getTokenInfo().companycode}/temporada`)
        let result = []

        if (res.data !== undefined) {
            for await (let el of res.data) {

                if (!el.info.avaiable) continue

                let aux = {
                    id: el.id,
                    name: translate(el.info.title, 'pt')
                }

                result.push(aux)
            }
        }

        return result
    }
    
    const fetch_competicoes = async () => {
            try {
                const res = await reqGET(`${api_crud_base}/intranet/components/type/${getTokenInfo().companycode}/competicoes`)
    
                if (res.data !== undefined) {
                    set_competicoes(res.data)
                }
            } catch (error) {
                console.error('Erro ao carregar lista de competições:', error)
            }
        }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create === false) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit === false) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove === false) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create === false) {
                            aux.create = node.create
                        }
                        if (aux.edit === false) {
                            aux.edit = node.edit
                        }
                        if (aux.remove === false) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    set_dados(permissions.current = aux)
                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            await fetch_competicoes()

            const temporadas = await fetch_temporadas()
            console.log('temporadas disponiveis:', temporadas)
            set_temporadas_lista(temporadas)

            await fetch_id_info()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    useEffect(() => {

        if (temporada_auto_definida.current) return
        if (temporadas_lista.length === 0) return

        const epoca_atual = normalizar_epoca(get_epoca_atual())
        const disponiveis = temporadas_lista.map(t => normalizar_epoca(t.name))

        if (disponiveis.includes(epoca_atual)) {
            set_temporada_filtro(epoca_atual)
        }

        temporada_auto_definida.current = true

    }, [temporadas_lista]);

    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: color.corPrimaria.rgb,
            cancelButtonColor: color.corVermelha.rgb,
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            setData(prev => prev.filter(el => el.id !== id))
                            setRefresh(r => r + 1)
                        })
                        .catch(error => console.log(error))
                }
            })

    }

    const get_competition_name = (id) => {
        return competicoes.find(e => parseInt(e.id) === parseInt(id))?.info.name
    }

    const columns = [
        {
            name: language[lang].jogo ?? 'Jogo',
            selector: 'info.equipa_casa.label',
            width: '20%',
            cell: row => <span>{get_jogo_label(row.info)}</span>,
            minWidth: '220px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].competition ?? 'Competição',
            selector: 'info.competition',
            cell: row => <span className="text-nowrap">{get_competition_name(row.info.competition)}</span>,
            width: '15%',
            minWidth: '150px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].epoca ?? 'Época',
            selector: 'info.temporada',
            width: '10%',
            cell: row => <span>{row.info?.temporada ?? '-'}</span>,
            minWidth: '90px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].modalidade ?? 'Modalidade',
            selector: 'info.modalidade',
            width: '10%',
            cell: row => <span>{get_label(modalidades_lista, row.info?.modalidade)}</span>,
            sortable: true,
            center: true,
        },
        {
            name: language[lang].tipo_jogo ?? 'Tipo de Jogo',
            selector: 'info.tipo_jogo',
            width: '10%',
            cell: row => <span>{get_label(tipo_jogo_lista, row.info?.tipo_jogo)}</span>,
            sortable: true,
            center: true,
        },
        {
            name: language[lang].data_jogo ?? 'Data',
            selector: 'info.data_jogo',
            width: '10%',
            minWidth: '100px !important',
            sortable: true,
            center: true,
            cell: row => <span>
                    {row.info?.data_jogo || '-'} {row.info?.hora_inicio || ''}
                </span>,
        },
        {
            name: language[lang].pista ?? 'Pista',
            selector: 'info.pista',
            width: '15',
            minWidth: '150px !important',
            sortable: true,
            left: true,
            cell: row => <span>{row.info?.pista || '-'}</span>,
        },
        {
            name: '',
            right: true,
            export: false,
            width: '10%',
            minWidth: '150px !important',
            cell: row =>
                <span>
                    <Link className="button button-update button-view p-1" to={{ pathname: endpoints.view, state: { item: { id: row.id }, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>

                    {permissions.current !== null && (permissions.current.edit) ? (
                        <Link
                            className="button button-update p-1"
                            to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }}
                            replace
                            aria-label="Edit Jogo"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <i className={icon.pencil.className} style={icon.pencil.style}></i>
                        </Link>
                    ) : null}

                    {permissions.current !== null && permissions.current.remove ? (
                        <button
                            className="button button-delete p-1"
                            onClick={(e) => { e.stopPropagation(); apagar(row['id']) }}
                            aria-label="Delete Jogo"
                        >
                            <i className={icon.trash.className} style={icon.trash.style}></i>
                        </button>
                    )
                        :
                        null
                    }
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const epocas_disponiveis = Array.from(new Set(
        temporadas_lista.map(t => normalizar_epoca(t.name)).filter(Boolean)
    )).sort((a, b) => a.localeCompare(b))

    const modalidades_ordenadas = [...modalidades_lista].sort((a, b) => a.label.localeCompare(b.label, 'pt'))

    const dados_filtrados = data.filter(d => {

        if (modalidade_filtro && d.info?.modalidade !== modalidade_filtro) return false

        if (temporada_filtro && normalizar_epoca(d.info?.temporada) !== temporada_filtro) return false

        if (pesquisa) {
            const termo = pesquisa.trim().toLowerCase()
            const campos = [
                get_jogo_label(d.info),
                d.info?.temporada,
                get_label(modalidades_lista, d.info?.modalidade),
                get_label(tipo_jogo_lista, d.info?.tipo_jogo),
                d.info?.data_jogo,
                d.info?.hora_inicio,
                d.info?.pista,
            ].filter(Boolean).join(' ').toLowerCase()
            if (!campos.includes(termo)) return false
        }

        return true
    })

    return (isloading ?

        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <h2 className="dash-title">{language[lang].jogo ?? 'Jogo'}</h2>
                <p>{language[lang].jogo_list ?? 'Listagem de Jogos'}</p>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">

                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">

                            <div className="pb-10">
                                <div className="div-table">
                                    <div className="table-header text-end mb-5 d-none">
                                        {permissions.current !== null && permissions.current.create && (
                                            <Link className="btn btn-sm btn-secondary rounded-0 multi-item" to={{ pathname: endpoints.regist }}>
                                                <span>{language[lang].add_new_jogo ?? 'Adicionar Novo Jogo'}</span>
                                            </Link>
                                        )}
                                    </div>

                                    <div className="table-filters mb-3">
                                        <div className="data-table-extensions">
                                            <div className="data-table-extensions-filter">
                                                <label htmlFor="filterDataTable" className="icon"></label>
                                                <input
                                                    type="text"
                                                    name="filterDataTable"
                                                    className="filter-text"
                                                    placeholder={language[lang].filter_placeholder}
                                                    value={pesquisa}
                                                    onChange={(e) => set_pesquisa(e.target.value)}
                                                />
                                            </div>
                                            <div className="data-table-extensions-action">
                                                <select
                                                    className="form-select form-select-sm"
                                                    style={{ maxWidth: '150px' }}
                                                    value={temporada_filtro}
                                                    onChange={(e) => set_temporada_filtro(e.target.value)}
                                                >
                                                    {epocas_disponiveis.map(ep => (
                                                        <option key={ep} value={ep}>{ep}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center flex-wrap" style={{ gap: '6px', padding: '0 1.2rem' }}>
                                            {modalidades_ordenadas.map(m => (
                                                <button
                                                    type="button"
                                                    key={m.value}
                                                    style={estilo_pill(modalidade_filtro === m.value)}
                                                    onClick={() => set_modalidade_filtro(prev => prev === m.value ? '' : m.value)}
                                                >
                                                    {m.label}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="table-body">
                                        <DataTable
                                            columns={columns}
                                            data={dados_filtrados}
                                            noDataComponent={language[lang].table_empty}
                                            noHeader
                                            pagination
                                            paginationComponentOptions={defaultComponentOptions}
                                            paginationPerPage={25}
                                            paginationRowsPerPageOptions={[25, 50, 100]}
                                            onRowClicked={handleRowClick}
                                            pointerOnHover
                                            highlightOnHover
                                            customStyles={{
                                                rows: {
                                                    style: {
                                                        // cursor: 'pointer',
                                                        minHeight: '24px',
                                                    },
                                                },
                                                headCells: {
                                                    style: {
                                                        padding: '2px',
                                                        fontSize: '12px',
                                                    },
                                                },
                                                cells: {
                                                    style: {
                                                        padding: '2px',
                                                        fontSize: '12px',
                                                    },
                                                },
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}